import {
  CreateCheckboxField,
  CreateFieldInput,
  CreateFieldSelect,
  CreateFieldTextarea,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class BillingCreate extends Page {
  static statusOptions = [
    { value: 'trialing', label: 'Trialing' },
    { value: 'active', label: 'Active' },
    { value: 'past_due', label: 'Past Due' },
    { value: 'canceled', label: 'Canceled' },
    { value: 'incomplete', label: 'Incomplete' }
  ];

  static nextSteps = [
    { icon: 'settings', label: 'Connect a Stripe customer' },
    { icon: 'chart', label: 'Track subscription status' },
    { icon: 'users', label: 'Associate account admins' },
    { icon: 'check', label: 'Manage renewal settings' }
  ];

  static timlComponents = {
    CreateCheckboxField,
    CreateFieldInput,
    CreateFieldSelect,
    CreateFieldTextarea,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('billing');
  }

  static timl = `
    .auth-create-page.billing-create-page
      <PageTitle title="Add Billing Profile">
      .auth-create-content
        p.auth-create-description Add billing and subscription details for this account.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/billing"]
            .create-form-body
              <CreateFieldInput label="Name" name="name" placeholder="e.g. Primary subscription" hint="A friendly name for these billing details.">
              <CreateFieldTextarea label="Description (optional)" name="description" placeholder="Add internal context" required="false" rows="4">
              <CreateFieldInput label="Stripe Customer ID (optional)" name="stripeCustomerId" placeholder="cus_..." required="false">
              <CreateFieldInput label="Stripe Subscription ID (optional)" name="stripeSubscriptionId" placeholder="sub_..." required="false">
              <CreateFieldInput label="Stripe Price ID (optional)" name="stripePriceId" placeholder="price_..." required="false">
              <CreateFieldSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}" value="trialing">
              <CreateFieldInput label="Plan name (optional)" name="planName" placeholder="e.g. Pro" required="false">
              <CreateFieldInput label="Current period start (optional)" name="currentPeriodStart" placeholder="YYYY-MM-DD" required="false">
              <CreateFieldInput label="Current period end (optional)" name="currentPeriodEnd" placeholder="YYYY-MM-DD" required="false">
              <CreateCheckboxField label="Cancel at period end" name="cancelAtPeriodEnd" hint="The subscription remains active until the current period ends.">
            <CreateFormActions submitLabel="Create" cancelHref="/billing">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
